define('rivets',["exports", "common", "node_modules/rivets/dist/rivets.min"], function (_exports, _common, _rivets) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _rivets = _interopRequireDefault(_rivets);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  function formatDMS(value) {
    var degree = Math.floor(value);
    value = (value - degree) * 60;
    var minutes = Math.floor(value);
    value = (value - minutes) * 60;
    var seconds = value.toFixed(1);
    return `${degree}°${minutes}′${seconds}″`;
  }
  _rivets.default.configure({
    preloadData: false,
    executeFunctions: true
  });
  _rivets.default.adapters[':'] = {
    observe(obj, keypath, cb) {
      obj.on(`change:${keypath}`, cb);
    },
    unobserve(obj, keypath, cb) {
      obj.off(`change:${keypath}`, cb);
    },
    get(obj, keypath) {
      return obj.get(keypath);
    },
    set(obj, keypath, value) {
      obj.set(keypath, value, {
        control: true,
        rivets: true
      });
    }
  };
  _rivets.default.binders.show = (el, value) => el.hidden = !value;
  _rivets.default.binders.hide = (el, value) => el.hidden = Boolean(value);
  _rivets.default.binders.value.bind = function (el) {
    if (el.type !== 'radio') {
      return el.addEventListener('change', this.publish, {
        passive: true
      });
    }
  };
  _rivets.default.binders.value.unbind = function (el) {
    if (el.type !== 'radio') {
      return el.removeEventListener('change', this.publish, {
        passive: true
      });
    }
  };
  _rivets.default.binders.invalid = {
    publishes: true,
    bind(el) {
      return el.addEventListener('invalid', this.publish, {
        passive: true
      });
    },
    unbind(el) {
      return el.removeEventListener('invalid', this.publish);
    },
    routine() {},
    publish() {
      return this.observer.publish(this.el.validationMessage);
    }
  };
  _rivets.default.formatters.switch = (value, ...sw) => {
    var _ref;
    value = String(value);
    var swDict = new Map();
    for (var i = 0; i < sw.length; i += 2) {
      swDict.set(sw[i], sw[i + 1]);
    }
    var res = (_ref = swDict.has(value) ? swDict.get(value) : swDict.get('$default')) !== null && _ref !== void 0 ? _ref : '';
    return res === '$value' ? value : res;
  };
  _rivets.default.formatters.eq = (v1, v2) => v1 == v2;
  _rivets.default.formatters.or = (v1, v2) => v1 || v2;
  _rivets.default.formatters.not = v1 => !v1;
  _rivets.default.formatters.cond = (v, c1, c2) => v ? c1 : c2;
  _rivets.default.formatters.num = {
    read(v) {
      return Number.isFinite(v) ? String(v) : '';
    },
    publish(v) {
      var n = Number(v);
      return Number.isFinite(n) ? n : null;
    }
  };
  _rivets.default.formatters['num?'] = v => Number.isFinite(v);
  _rivets.default.formatters.dateRange = range => {
    if (!range) {
      return '';
    }
    var df = new Intl.DateTimeFormat(GA.lcDate, {
      dateStyle: 'long'
    });
    var start = new Date(range.start);
    var end = new Date(range.end);
    return range.end ? df.formatRange(start, end) : df.format(start);
  };
  _rivets.default.formatters.price = (value, currency) => (0, _common.formatPrice)(value, currency);
  _rivets.default.formatters.number = value => (0, _common.formatNumber)(value);
  _rivets.default.formatters.currencyRange = range => {
    if (range && (range.start || range.end)) {
      var _range$start;
      var symbol = (0, _common.formatPrice)(0).replace('0', '');
      var str = (0, _common.formatPrice)((_range$start = range.start) !== null && _range$start !== void 0 ? _range$start : 0);
      var p = str.indexOf(symbol);
      if (range.end) {
        return p === 0 ? `${str}-${(0, _common.formatPrice)(range.end).replace(symbol, '')}` : `${str.replace(symbol, '')}-${(0, _common.formatPrice)(range.end)}`;
      } else {
        return p > 0 ? `${str.substring(0, p)}+${str.substring(p)}` : `${str}+`;
      }
    }
  };
  _rivets.default.formatters.areaRange = range => {
    if (range && (range.start || range.end)) {
      if (range.end) {
        var _range$start2;
        return `${(_range$start2 = range.start) !== null && _range$start2 !== void 0 ? _range$start2 : 0}-${range.end} m²`;
      } else {
        return `${range.start}+ m²`;
      }
    }
  };
  _rivets.default.formatters.longitude = value => Number.isFinite(value) ? `${formatDMS(Math.abs(value))}${value >= 0 ? 'E' : 'W'}` : '';
  _rivets.default.formatters.latitude = value => Number.isFinite(value) ? `${formatDMS(Math.abs(value))}${value >= 0 ? 'N' : 'S'}` : '';
  var _default = _exports.default = _rivets.default;
});//# sourceMappingURL=rivets.js.map
;
